import { CheckoutConfig } from './CheckoutConfig';
import { FeatureKey } from './CheckoutFeatures';

export const featureEnabled = (config: CheckoutConfig, feature: FeatureKey) =>
  config.features?.[feature];
